var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from '../../utils/styled-components';
import useTracking from '../../hooks/useTracking';
import prepareEECproductClick from './prepareEECproductClick';
import ProductLink from '../../Link/ProductLink';
var StyledLink = styled(ProductLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: none;\n  color: inherit;\n  ", "\n"], ["\n  text-decoration: none;\n  color: inherit;\n  ",
    "\n"])), function (_a) {
    var productImageLink = _a.productImageLink;
    return productImageLink
        ? "\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  "
        : '';
});
var Link = function (_a) {
    var _b = _a.categoryName, categoryName = _b === void 0 ? '' : _b, _c = _a.href, href = _c === void 0 ? '#' : _c, _d = _a.brand, brand = _d === void 0 ? '' : _d, _e = _a.onClickAdditional, onClickAdditional = _e === void 0 ? function () { } : _e, name = _a.name, pid = _a.pid, position = _a.position, priceValue = _a.priceValue, list = _a.list, productImageLink = _a.productImageLink, trackingToken = _a.trackingToken, children = _a.children;
    var dispatchGTMEvent = useTracking();
    return children ? (React.createElement(StyledLink, { "data-testid": "productLink", productImageLink: productImageLink, href: href, title: name, onClick: function () {
            dispatchGTMEvent(prepareEECproductClick({
                brand: brand,
                categoryName: categoryName,
                list: list,
                name: name,
                pid: pid,
                position: position,
                priceValue: priceValue,
                trackingToken: trackingToken,
            }));
            onClickAdditional();
        } }, children)) : null;
};
export default Link;
var templateObject_1;
//# sourceMappingURL=index.js.map